import { render, staticRenderFns } from "./dosageProduct.html?vue&type=template&id=fb4a8932&scoped=true&"
import script from "./dosageProduct.js?vue&type=script&lang=js&"
export * from "./dosageProduct.js?vue&type=script&lang=js&"
import style0 from "./dosageProduct.scss?vue&type=style&index=0&id=fb4a8932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4a8932",
  null
  
)

export default component.exports